<template>
  <div :class="{ 'select-box': true, 'readonly-cls': readonly }">
    <van-field
      :label="label"
      clearable
      :required="required"
      :placeholder="'请选择' + label"
      @click="handleSelect"
      v-model="selVal"
      right-icon="arrow"
      readonly
    />
    <van-popup v-model="visible" position="bottom" :style="{ height: '40%' }">
      <van-picker
        :columns="columns"
        :value-key="textKey"
        show-toolbar
        :default-index="defaultIndex"
        cancel-button-text="清除"
        @cancel="onCancel"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { Field, Popup, Picker } from "vant";
import cloneDeep from "lodash/cloneDeep";

export default {
  components: {
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
  },
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    valueKey: {
      type: [String, Number],
      default: "Id",
    },
    textKey: {
      type: [String, Number],
      default: "Text",
    },
    required: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default() {
        return [];
      },
    },
    label: {
      type: String,
      default: "",
    },
    defaultValue: {
      type: [Number, String],
      default: "",
    },
    change: { type: Function },
  },
  model: {
    prop: "value",
    event: "update",
  },
  data() {
    return {
      selVal: "",
      selectKey: "",
      visible: false,
    };
  },
  watch: {
    columns() {
      this.copyData();
    },
    value() {
      this.copyData();
    },
    selectKey(val) {
      this.$emit("update", val);
    },
  },
  computed: {
    defaultIndex() {
      const index = this.columns.findIndex(
        p => p[this.valueKey] == this.selectKey,
      );
      return index > -1 ? index : 0;
    },
  },
  created() {
    this.copyData();
  },
  methods: {
    copyData() {
      this.selectKey = cloneDeep(this.value);
      if (this.value || this.value == 0) {
        const result = this.columns.find(p => p[this.valueKey] == this.value);
        if (result) {
          this.selVal = result[this.textKey];
        } else {
          this.selVal = "";
          this.selectKey = "";
        }
      } else {
        this.selVal = "";
      }
    },
    handleSelect() {
      if (!this.readonly) {
        this.visible = true;
      }
    },
    onConfirm(data) {
      this.selVal = data[this.textKey];
      this.selectKey = data[this.valueKey];
      this.$emit("change", data);
      this.visible = false;
      this.$emit("destroy");
    },
    onCancel() {
      this.selVal = "";
      this.selectKey = "";
      this.visible = false;
      this.$emit("change", "");
      this.$emit("destroy");
    },
  },
};
</script>

<style lang="less" scoped>
.select-box {
  /deep/.van-cell::after {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 0;
    bottom: 0;
    left: 0.42667rem;
    border-bottom: 0.02667rem solid #ebedf0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
  /deep/.van-cell {
    // border-bottom: 1px solid #eaeaea;
    .van-field__label {
      width: 1.9rem;
    }
    &.money:not(:last-child)::after {
      border-bottom: 0;
    }
  }
  /deep/.van-field__control:disabled {
    color: #323233;
    -webkit-text-fill-color: #323233;
  }
  /deep/.van-field__control:disabled::-webkit-input-placeholder {
    /* WebKit browsers */
    -webkit-text-fill-color: #999;
  }
  /deep/.van-popup {
    overflow: hidden;
  }
}
.readonly-cls {
  background: #f9f9f9 !important;
  .van-field__right-icon {
    display: none;
  }
  .van-cell {
    background: #f9f9f9 !important;
    .van-field__control {
      color: #999;
    }
  }
  &.van-cell {
    background: #f9f9f9 !important;
    .van-field__control {
      color: #999;
    }
  }
}
</style>
